export function removeUserTrashFields (field) {
    return new Promise(resolve => {
        Object.assign(field, 
            {   
                blocked : false,
                main : false,
                acceptedAt : new Date()
            })
        delete field.companyName
        delete field.active
        delete field.accepted
        delete field.emailVerified
        delete field.companyLogo
        delete field.createdOn
        delete field.isAnonymous
        if(field.hasOwnProperty('providerData')) delete field.providerData

        resolve(field)
    })
}